var React = require('react');

function CloseIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"36.0067","height":"2.40044","rx":"1.20022","transform":"matrix(0.707108 -0.707106 0.707108 0.707106 0.817871 26.0952)","fill":"#3E1052","key":0}),React.createElement("rect",{"x":"2.51514","y":"0.634766","width":"36.0066","height":"2.40044","rx":"1.20022","transform":"rotate(45 2.51514 0.634766)","fill":"#3E1052","key":1})]);
}

CloseIcon.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = CloseIcon;

CloseIcon.default = CloseIcon;
